import { PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from '../../../environments/environment';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: environment.keycloak.authority,
    redirectUrl: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    clientId: environment.keycloak.clientId,
    scope: 'openid profile email offline_access',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 60,
    silentRenewTimeoutInSeconds: 10,
    secureRoutes: [environment.apiBaseUrl],
    logLevel: environment.production ? 0 : 1,
    // PAR (Pushed Authorization Requests) - required by KeyCloak
    usePushedAuthorisationRequests: true,
  },
};
